import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountUpModule } from 'ngx-countup';

import { QuizProgressComponent } from './quiz-progress.component';


@NgModule({
    declarations: [QuizProgressComponent],
    exports: [QuizProgressComponent],
    imports: [
        CommonModule,
        CountUpModule
    ]
})
export class QuizProgressModule { }
